import checkPermission from './CheckPermission';

export default function checkAdmin(settings, profile) {
    const permission = checkPermission(profile, ['master', 'super_admin']);
    const pluginspace = settings.pluginspace || {};

    return permission && pluginspace.subdomain === 'admin';
}
